import { Text } from '@thefarmersfront/kitchen';

import { AiStarsGradientIcon } from '~/components/common/Icon';

import styles from './SmartSearchLoading.module.scss';

const SmartSearchLoading = () => {
  return (
    <div className={styles['loading']}>
      <div className={styles['loading-icon']}>
        <AiStarsGradientIcon size={52} />
      </div>
      <Text className={styles['loading-message']} size="xxlarge" weight="semi-bold" align="center">
        {'답변을 준비하고 있어요.\n잠시만 기다려주세요.'}
      </Text>
    </div>
  );
};

export default SmartSearchLoading;
